/**
 * HamburguerMenuIcon component
 *
 * Renders an SVG icon representing a hamburger menu.
 * It is intended to be used as a trigger for opening mobile navigation menus.
 *
 * @param {number|string} size - The width and height of the icon (default: 32).
 * @param {string} color - The fill color of the icon (default: "#1C1B1F").
 * @returns {JSX.Element} The SVG hamburger menu icon.
 */
const HamburguerMenuIcon = ({ size = 32, color = '#1C1B1F' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.33333 24C4.95556 24 4.63911 23.872 4.384 23.616C4.128 23.3609 4 23.0444 4 22.6667C4 22.2889 4.128 21.9724 4.384 21.7173C4.63911 21.4613 4.95556 21.3333 5.33333 21.3333H26.6667C27.0444 21.3333 27.3609 21.4613 27.616 21.7173C27.872 21.9724 28 22.2889 28 22.6667C28 23.0444 27.872 23.3609 27.616 23.616C27.3609 23.872 27.0444 24 26.6667 24H5.33333ZM5.33333 17.3333C4.95556 17.3333 4.63911 17.2053 4.384 16.9493C4.128 16.6942 4 16.3778 4 16C4 15.6222 4.128 15.3053 4.384 15.0493C4.63911 14.7942 4.95556 14.6667 5.33333 14.6667H26.6667C27.0444 14.6667 27.3609 14.7942 27.616 15.0493C27.872 15.3053 28 15.6222 28 16C28 16.3778 27.872 16.6942 27.616 16.9493C27.3609 17.2053 27.0444 17.3333 26.6667 17.3333H5.33333ZM5.33333 10.6667C4.95556 10.6667 4.63911 10.5391 4.384 10.284C4.128 10.028 4 9.71111 4 9.33333C4 8.95556 4.128 8.63867 4.384 8.38267C4.63911 8.12756 4.95556 8 5.33333 8H26.6667C27.0444 8 27.3609 8.12756 27.616 8.38267C27.872 8.63867 28 8.95556 28 9.33333C28 9.71111 27.872 10.028 27.616 10.284C27.3609 10.5391 27.0444 10.6667 26.6667 10.6667H5.33333Z"
      fill={color}
    />
  </svg>
);

export default HamburguerMenuIcon;
